import { render, staticRenderFns } from "./HoldingsPieChartDialog.vue?vue&type=template&id=9b6a218a&scoped=true&"
import script from "./HoldingsPieChartDialog.vue?vue&type=script&lang=js&"
export * from "./HoldingsPieChartDialog.vue?vue&type=script&lang=js&"
import style0 from "./HoldingsPieChartDialog.vue?vue&type=style&index=0&id=9b6a218a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b6a218a",
  null
  
)

export default component.exports